<template>
    <button @click.prevent="copy" class="btn btn-primary">
        <i class="icon ion-ios-clipboard"></i>
        {{ 'copy.toClipboard' | lang }}
    </button>
</template>

<script>
  import TToast from '@/js/components/TToast';
  import FakeElement from '@/js/library/FakeElement';

  export default {
    name: 'TournCopy',
    props: {
      copies: String,
      container: HTMLDivElement,
    },
    data() {
      return {
        toast: new TToast,
        copied: window.Lang.get('copy.copied'),
        notCopied: window.Lang.get('copy.notCopied'),
      };
    },
    methods: {
      copy(event) {
        const config = {
          text: this.copies,
          trigger: event.currentTarget,
          container: this.container || document.body,
        };
        let status;
        try {
          status = (new FakeElement(config)).auto();
        } catch (error) {
          status = false;
        }
        this.handleToast(status);
      },
      handleToast(status) {
        if (status) {
          this.toast.success(this.copied);
          return;
        }
        this.toast.error(this.notCopied);
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
